import { type AppThunk } from "../../../index";
import { clearSearchTerm } from "../reducer";
import { fetchIngredients } from "./fetchIngredients";

export const clearSearchingIngredient = (): AppThunk => (dispatch) => {
  dispatch(clearSearchTerm());
  void dispatch(fetchIngredients());
};
